export default "__VITE_ASSET__$Baqz$Yc__"